<div class="tw-px-5">
  <div class="tw-flex tw-gap-2 tw-bg-gradient-teal-right tw-px-5 tw-py-8 tw-border tw-border-gray-50 tw-rounded-2xl tw-shadow-z1" (click)="bannerClick()">
    <div class="tw-w-[50%] tw-flex tw-flex-col tw-justify-center tw-items-start">
      <span
        [ngClass]="([appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')) ? 'tw-text-200' : 'tw-text-500')"
        class="tw-mb-4">
        <p class="tw-capitalize">{{ username }},</p>
        <h1 i18n="@@checkYourSkinProgress">check your skin progress</h1>
      </span>
      <div [ngClass]="([appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')) ? 'tw-px-3 tw-text-100' : 'tw-px-5 tw-text-300')"
        class="tw-w-fit tw-bg-teal-600 tw-text-white tw-py-2 tw-rounded-xl tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden tw-text-center tw-shadow-z1"
      >
        <span i18n="@@takePhoto">Take Photo</span>
      </div>
    </div>
    <div class="tw-flex tw-justify-end tw-items-center">
      <div class="tw-w-[98px] tw-h-[98px] tw-relative -tw-mr-14 -tw-mt-8 tw-rounded-xl tw-overflow-hidden tw-border tw-border-gray-50 tw-shadow-z1">
        <span class="tw-absolute tw-top-0 tw-left-2 tw-bg-white tw-text-teal-700 tw-text-50 tw-font-bold tw-px-3 tw-rounded-b-lg tw-leading-none tw-py-1 tw-uppercase tw-z-[5]"><span i18n="@@day">Day</span> 0</span>
        <img [src]="userInitialImage" class="tw-w-full tw-h-full tw-object-cover tw-grayscale" />
      </div>
      <div class="tw-w-24 tw-h-24 tw-relative tw-rounded-lg tw-overflow-hidden -tw-mb-9 tw-bg-white tw-shadow-z1 tw-flex tw-justify-center tw-items-center">
        <span class="tw-absolute tw-top-0 tw-left-2 tw-bg-teal-300 tw-text-teal-700 tw-text-50 tw-font-bold tw-px-3 tw-rounded-b-lg tw-leading-none tw-py-1 tw-uppercase"><span i18n="@@day">Day</span> {{ daysSinceLastDelivery }}</span>
        <div class="tw-flex tw-flex-col tw-justify-center tw-items-center -tw-mb-1">
          <img src="https://cdn.cureskin.com/app/img/add_photo.svg" class="tw-w-5" alt=""/>
          <p
            [ngClass]="([appConfig.Shared.Languages.ML, appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')) ? 'tw-leading-3' : '')"
            class="tw-text-50 tw-text-gray-400 tw-text-center" i18n="@@addPhoto"
          >Add Photo</p>
        </div>
      </div>
    </div>
  </div>
  <div class="tw-invisible">
    <file-picker (onFileChange)="uploadImageFromNativeCamera($event)" capture="user"></file-picker>
  </div>
</div>
